import { FunctionComponent } from "react";
import { IonSpinner, IonText } from "@ionic/react";
import { EditPlaceholderSiteList } from "./edit-placeholder-site-list.component";

export const LoadingSiteListComponent: FunctionComponent<{ message: string }> = ({ message }) => (
  <EditPlaceholderSiteList>
    <IonSpinner />
    <IonText>{message}</IonText>
  </EditPlaceholderSiteList>
);
